var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * [CLAIMS_CONTEXT]
 * purpose: Displays and manages fence damage information including fence type, height and length.
 * touches: declaration, externalDamage, fenceDamage
 * invariants: Fence type choices depend on the damage origin; the selected fence type is synchronized with isFenceHalfHeight and fenceLength in the FenceDamage model.
 * inputs: externalDamage, damageOrigin, FENCE_TYPE_TRAD_KEYS, fenceLength, fenceTypeChoices
 * outputs: updates external damage data through updateExternalDamage with fence type, height and length; displays validation errors for fenceType and fenceLength fields.
 * see: @declaration/components/externalDamage/ExternalDamageComponent, @shared/types/api/externalDamage, @shared/constants/externalDamages, @shared/choice
 */
import Component from 'vue-class-component';
import { UiRadio, UiCard } from '@claims-ia/design-system';
import { ExternalDamageComponent } from '../ExternalDamageComponent';
import LengthInput from '@declaration/components/LengthInput.vue';
import { FENCE_TYPE_TRAD_KEYS } from '@shared/constants/externalDamages';
import { FENCE_LENGHT_LABEL, FENCE_LENGHT_TITLE, FENCE_SUB_TITLE, FENCE_TITLE, FENCE_TYPE_FULL_HEIGHT_IMAGES, FENCE_TYPE_HALF_HEIGHT_IMAGES, FENCE_TYPE_OTHER_IMAGE, } from '@declaration/constants/externalDamages';
import { FenceType } from '@shared/types/api/externalDamage';
import { objectToBooleanImageChoices } from '@shared/choice';
let Fence = class Fence extends ExternalDamageComponent {
    get title() {
        return this.translateExternalDamageKey(FENCE_TITLE);
    }
    get subTitle() {
        return this.translateExternalDamageKey(FENCE_SUB_TITLE);
    }
    get lengthTitle() {
        return this.translateExternalDamageKey(FENCE_LENGHT_TITLE);
    }
    get lengthLabel() {
        return this.translateExternalDamageKey(FENCE_LENGHT_LABEL);
    }
    get fenceTypeChoices() {
        const damageOrigin = this.damageOrigin;
        if (!damageOrigin)
            return [];
        return Object.values(FenceType)
            .filter((val) => val !== FenceType.Other)
            .map((fenceType) => {
            return {
                fenceType,
                tradKey: FENCE_TYPE_TRAD_KEYS[damageOrigin][fenceType],
                choices: objectToBooleanImageChoices({
                    true: FENCE_TYPE_HALF_HEIGHT_IMAGES[fenceType],
                    false: FENCE_TYPE_FULL_HEIGHT_IMAGES[fenceType],
                }).map((choice) => ({
                    value: choice.value,
                    label: '',
                    imageSrc: choice.image,
                })),
            };
        })
            .concat([
            {
                fenceType: FenceType.Other,
                tradKey: FENCE_TYPE_TRAD_KEYS[damageOrigin][FenceType.Other],
                choices: [
                    {
                        value: true,
                        label: '',
                        imageSrc: FENCE_TYPE_OTHER_IMAGE,
                    },
                ],
            },
        ]);
    }
    getIsFenceHalfHeight(fenceType) {
        var _a;
        if (this.externalDamage.fenceType === fenceType) {
            return (_a = this.externalDamage.isFenceHalfHeight) !== null && _a !== void 0 ? _a : null;
        }
        return null;
    }
    setIsFenceHalfHeight(fenceType, isFenceHalfHeight) {
        this.updateExternalDamage({ fenceType, isFenceHalfHeight });
    }
    get fenceLength() {
        if (this.externalDamage.fenceLength)
            return this.externalDamage.fenceLength;
        return null;
    }
    set fenceLength(fenceLength) {
        if (fenceLength)
            this.updateExternalDamage({ fenceLength });
        else
            this.updateExternalDamage({ fenceLength: null });
    }
};
Fence = __decorate([
    Component({ components: { UiRadio, UiCard, LengthInput } })
], Fence);
export default Fence;
